import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { useHistory } from 'react-router';
import { Actions as ADMINACTIONS } from '../../store/actions/adminActions';
import OrganisationsRow from './OrganisationsRow';

import { Button } from '../ui/button';
import { Card, CardContent, CardHeader, CardTitle } from '../ui/card';
import { Table, TableBody, TableHead, TableHeader, TableRow, TableCell } from '../ui/table';
import { Spinner } from '../ui/spinner';
import _ from 'lodash';

const OrganisationsTable = ({
  list,
  showLoader,
  ambassadorAdmin,
  toggleModal,
  currentOrgDetails,
  currentOrganisationId,
  adminUser,
  getAllItemsFromDB,
}) => {
  const history = useHistory();

  useEffect(() => {
    getAllItemsFromDB('currencies');
  }, [getAllItemsFromDB]);

  const sortedOrgList = adminUser
    ? _.sortBy(list, [(org) => (String(org?.id) === String(currentOrganisationId) ? 0 : 1), 'id'])
    : _.sortBy(list, 'id');

  const handleAddOrganisation = () => {
    // Check if the organisation details are available and if the organisation creation is disabled, and user is not an admin
    if (currentOrgDetails?.id && !currentOrgDetails?.organisationCreation && !adminUser) {
      toggleModal(true, 'organisationCreation-disabled', null);
    } else {
      history.push('/organisations/new');
    }
  };

  return (
    <div className='w-full'>
      <Card className='border rounded-md'>
        <CardHeader className='flex flex-row items-center justify-between pb-2'>
          <CardTitle className='uppercase text-xl font-semibold'>Your Organisations</CardTitle>
          {!showLoader && !ambassadorAdmin && (
            <Button
              onClick={handleAddOrganisation}
              className='mt-auto font-semibold text-base bg-secondary text-secondary-foreground hover:text-primary-foreground'>
              Add an Organisation
            </Button>
          )}
        </CardHeader>
        <CardContent className='p-0'>
          {showLoader && !list.length ? (
            <div className='mt-4 w-full flex items-center justify-center p-8'>
              <Spinner size='large' />
            </div>
          ) : (
            <div className='overflow-x-auto m-4'>
              <Table className='w-full '>
                <TableHeader>
                  <TableRow>
                    <TableHead>Organisation</TableHead>
                    <TableHead>Industry</TableHead>
                    <TableHead>Currency</TableHead>
                    <TableHead className='text-center'>Action</TableHead>
                  </TableRow>
                </TableHeader>
                <TableBody>
                  {list &&
                    Array.isArray(sortedOrgList) &&
                    sortedOrgList.map((organisationDetails, index) => (
                      <OrganisationsRow key={index} organisationDetails={organisationDetails} />
                    ))}
                  {sortedOrgList?.length === 0 && (
                    <TableRow>
                      <TableCell colSpan={4} className='text-center font-semibold text-base'>
                        No organisations available
                      </TableCell>
                    </TableRow>
                  )}
                </TableBody>
              </Table>
            </div>
          )}
        </CardContent>
      </Card>
    </div>
  );
};

/**
 * Membership orgs (`/my/organisations`) plus the navbar selection when an admin
 * is working in an organisation they are not a member of.
 *
 * @param {Array<object>} membership
 * @param {string|number|null|undefined} currentId
 * @param {object|null|undefined} currentDetails
 * @param {Array<object>} adminOrganisations
 * @param {boolean} adminUser
 * @returns {Array<object>}
 */
const organisationsForTable = (membership, currentId, currentDetails, adminOrganisations, adminUser) => {
  const memberOrgs = Array.isArray(membership) ? membership : [];
  if (!adminUser || !currentId || memberOrgs.some((org) => String(org?.id) === String(currentId))) {
    return memberOrgs;
  }

  const selected =
    (currentDetails?.id && String(currentDetails.id) === String(currentId) && currentDetails) ||
    (adminOrganisations || []).find((org) => String(org?.id) === String(currentId));

  return selected?.id ? [selected, ...memberOrgs] : memberOrgs;
};

const mapStateToProps = (state) => {
  const { ambassadorAdmin, cyfAdmin, whiteLabelAdmin, consultantAdmin } = state?.profile?.details || {};
  const orgDetails = state?.organisation?.details;
  const adminUser = cyfAdmin || whiteLabelAdmin || consultantAdmin;
  const currentOrganisationId = state.currentOrganisation;

  return {
    ambassadorAdmin,
    list: organisationsForTable(
      state.organisation?.list,
      currentOrganisationId,
      orgDetails,
      state?.admin?.organisations,
      adminUser,
    ),
    currentOrganisationId,
    showLoader: state?.showLoader,
    currentOrgDetails: orgDetails,
    allOrgs: state?.admin?.organisations,
    adminUser,
  };
};

const mapDispatchToProps = (dispatch) => ({
  toggleModal: (status, action, item, notAutoClose) =>
    dispatch(ADMINACTIONS.toggleModal(status, action, item, notAutoClose)),
  getAllItemsFromDB: (table) => dispatch(ADMINACTIONS.getAllItemsFromDB(table)),
});

export default connect(mapStateToProps, mapDispatchToProps)(OrganisationsTable);
